// EngagementsPage.jsx

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Engagements from '@/components/data/engagements/Engagements';
import PageHeading from '@/components/common/PageHeading';
import LoadingOverlay from '@/components/common/LoadingOverlay';

// Services
import { getEngagements } from '@/services/schedulingService';

const EngagementsPage = () => {
  const { t } = useTranslation();

  const [engagements, setEngagements] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const engagements = await getEngagements(52); // Full 52 weeks (1 year)
        setEngagements(engagements);
      } catch (error) {
        console.error('Error fetching engagements data:', error);
        setEngagements([
          {
            AllocationID: '1',
            ProfessionalID: '101',
            ProfessionalName: 'Joana',
            FunctionLevel: '1000',
            FunctionName: 'Analista',
            Office: 'Porto',
            ProfessionalRC: 'PT1',
            ProfessionalNotes: '',
            EngagementID: '201',
            EngagementName: 'BBC - Documentary',
            Client: 'British Broadcasting Corporation',
            ClientCode: 'BBC',
            Type: 'External',
            Status: 'Online',
            Manager: '',
            EngagementRC: 'PT1',
            EngagementNotes: '',
            StartDate: '2024-04-29',
            Hours: '8'
          },
          {
            AllocationID: '2',
            ProfessionalID: '102',
            ProfessionalName: 'Paulo',
            FunctionLevel: '2000',
            FunctionName: 'Consultor',
            Office: 'Porto',
            ProfessionalRC: 'PT1',
            ProfessionalNotes: '',
            EngagementID: '202',
            EngagementName: 'ABC - Documentary',
            Client: 'British Broadcasting Corporation',
            ClientCode: 'BBC',
            Type: 'External',
            Status: 'Online',
            Manager: '',
            EngagementRC: 'PT1',
            EngagementNotes: '',
            StartDate: '2024-04-29',
            Hours: '8'
          }
        ]);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  // No filtering needed anymore
  const filteredEngagements = engagements || [];

  return (
    <div className='workspace-management-page'>
      {loading && <LoadingOverlay />}
      <PageHeading title='Engagements'>
        <span className='workspace-count'>{new Set(filteredEngagements.map(e => e.EngagementID)).size} projects</span>
      </PageHeading>
      <Engagements engagements={filteredEngagements} />
    </div>
  );
};
export default EngagementsPage;
